import { call, put, select, all, takeLatest } from 'redux-saga/effects'
import { setMasterDataDetails } from '../actions/masterDataActions'
import {
          getRegionMaster,
          getCountryMaster,
          getAirportMaster,

} from '../../services/masterDataServices'
import {
          // getAirports,
          getShippingItems,
          getScc,
          getServices,
          getSccMaster,
          getAdditionalSccs,  

} from '../../services/searchPanelServices'
import {
          getProducts

} from '../../services/manageBookingService'
import {
          getTermsCountries

} from '../../services/adminMasterServices'
import {
          getChargeHeads,
          getCurrencyList

} from '../../services/dataCaptureService'
import {
         getUnidInfo

} from '../../services/dgBookingServices'
import { MASTER_DATA } from '../constants'


const getMasterData = state => state.masterData


export function* loadMasterDataSaga() {
          
          const masterData = yield select(getMasterData)
       

          const isAlreadyLoaded =
                    (masterData?.regionMaster && masterData.regionMaster.length > 0) ||
                    (masterData?.airportMaster && masterData.airportMaster.length > 0) ||
                    (masterData?.countryMaster && masterData.countryMaster.length > 0) ||
                    (masterData?.airportsMaster && masterData.airportsMaster.length > 0) ||
                    (masterData?.shippingItemsMaster && masterData.shippingItemsMaster.length > 0) ||
                    (masterData?.sccMaster && masterData.sccMaster.length > 0) ||
                    (masterData?.servicesMaster && masterData.servicesMaster.length > 0) ||
                    (masterData?.productsMaster && masterData.productsMaster.length > 0) ||
                    (masterData?.termsCountriesMaster && masterData.termsCountriesMaster.length > 0) ||
                    (masterData?.chargeHeadsMaser && masterData.chargeHeadsMaser.length > 0) ||
                    (masterData?.currencyListMaster && masterData.currencyListMaster.length > 0)||
                    (masterData?.sccListMaster && masterData.sccListMaster.length > 0) ||
                    (masterData?.unidListMaster && masterData.unidListMaster.length > 0) ||
                    (masterData?.additionalSccsMaster && masterData.additionalSccsMaster.length > 0)

          if (isAlreadyLoaded) {
                   

                    return
          }
          
          try {

                    const [
                              regionMaster,
                              airportMaster,
                              countryMaster,
                              // airportsMaster,
                              shippingItemsMaster,
                              scc,
                              servicesResponse,
                              productsMaster,
                              termsCountriesMaster,
                              chargeHeadsMaser,
                              currencyListMaster,
                              sccListMaster,
                              unidListMaster,
                              additionalSccsMaster

                    ] = yield all([
                              call(getRegionMaster),
                              call(getAirportMaster),
                              call(getCountryMaster),
                              // call(getAirports),
                              call(getShippingItems),
                              call(getScc),
                              call(getServices),
                              call(getProducts),
                              call(getTermsCountries),
                              call(getChargeHeads),
                              call(getCurrencyList),
                              call(getSccMaster),
                              call(getUnidInfo),
                              call(getAdditionalSccs)


                    ])

                    const servicesMaster = servicesResponse?.services || []

                    


                    const masterDataPayload = {
                              regionMaster: regionMaster?.length > 0 ? regionMaster : [],
                              airportMaster: airportMaster?.length > 0 ? airportMaster : [],
                              countryMaster: countryMaster?.length > 0 ? countryMaster : [],
                              // airportsMaster: airportsMaster?.length > 0 ? airportsMaster : [],
                              shippingItemsMaster: shippingItemsMaster?.length > 0 ? shippingItemsMaster : [],
                              sccMaster: scc?.length > 0 ? scc : [],
                              servicesMaster: servicesMaster?.length > 0 ? servicesMaster : [],
                              // uldTypeByCodeMaster: [],
                              // uldTypesMaster: {},
                              productsMaster: productsMaster?.length > 0 ? productsMaster : [],
                              termsCountriesMaster: termsCountriesMaster?.length > 0 ? termsCountriesMaster : [],
                              chargeHeadsMaser: chargeHeadsMaser?.length > 0 ? chargeHeadsMaser : [],
                              currencyListMaster: currencyListMaster?.length > 0 ? currencyListMaster : [],
                              sccListMaster: sccListMaster?.scc?.length > 0 ? sccListMaster.scc : [],
                              unidListMaster: unidListMaster?.length > 0 ? unidListMaster : [],
                              additionalSccsMaster: additionalSccsMaster?.length > 0 ? additionalSccsMaster : [],


                    }


                    yield put(setMasterDataDetails(masterDataPayload))

                   

          } catch (error) {
                   


          }


}

export default function* masterDataSaga() {
          yield takeLatest(MASTER_DATA.FETCH_ALL, loadMasterDataSaga)
}
